import gql from "graphql-tag";

const SERVER_REQUESTS_QUERY = gql`
  query ServerRequestsQuery($limit: Int!, $offset: Int!, $orderBy: String!, $status: ServerRequestStatusEnum) {
    serverRequests(limit: $limit, offset: $offset, orderBy: $orderBy, status: $status) {
      id
      endpoint
      method
      status
      data
      concreteShipmentId
      manualOperationId
      inventoryEntryId
      attempts
      lastError
      nextRetryAt
      insertedAt
    }
  }
`;

export default SERVER_REQUESTS_QUERY;
